const COLOR = {
  COMIC: '#41b883',
  NEW: '#61dafb',
  WEBCOMIC: '#026e00',
  ART: '#e44d26',
  POST: '#2ea1ff',
  UPDATE: '#f0db4f',
  ANNOUNCEMENT: '#1a6fb4',
};
Object.freeze(COLOR);


export { COLOR };
